import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Assessment
export const createAssessment = (payload) => api.post("/assessments", payload).then((r) => r.data);
export const submitEmail = (id, payload) => api.post(`/assessments/${id}/email`, payload).then((r) => r.data);
export const generateReport = (id) => api.post(`/assessments/${id}/report`).then((r) => r.data);
export const getPreview = (id) => api.get(`/assessments/${id}/preview`).then((r) => r.data);
export const getFullReport = (id) => api.get(`/assessments/${id}/full`).then((r) => r.data);

// Payments
export const createCheckout = (assessment_id, origin_url) =>
  api.post(`/payments/checkout`, { assessment_id, origin_url }).then((r) => r.data);
export const getPaymentStatus = (session_id) =>
  api.get(`/payments/status/${session_id}`).then((r) => r.data);
